import { Stack } from "@mui/material";
import BMIInfoCard from ".";

export default function BMIInfoCardExamples() {
  return (
    <Stack gap={3} width="100%">
      <BMIInfoCard
        bmi={21}
        weightKg={84}
        heightCm={165}
        lastUpdated="2025-02-23T00:00:00Z"
      />
      <BMIInfoCard
        bmi={29}
        weightKg={84}
        heightCm={165}
        lastUpdated="2025-02-20T00:00:00Z"
      />
      <BMIInfoCard
        bmi={31.22}
        weightKg={84}
        heightCm={165}
        lastUpdated="2025-02-18T00:00:00Z"
      />
      <BMIInfoCard
        bmi={15}
        weightKg={45}
        heightCm={175}
        lastUpdated="2025-02-15T00:00:00Z"
      />
    </Stack>
  );
}
